export default function History() {
    return <div>
    </div>
}
